module.exports = __webpack_public_path__ + "fonts/roboto-italic-webfont.woff2";